module.exports = __webpack_public_path__ + "static/media/tt.fbc6495c.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/tt.svg
// module id = 1179
// module chunks = 0